import React, { useState, useRef, useEffect } from "react";
import StudentLayout from "../../layout/StudentLayout";
import { AiOutlineSearch } from "react-icons/ai";
import { RiArrowDropUpLine, RiArrowDropDownLine } from "react-icons/ri";
import StudentsJourney from "../../assets/images/studentsJourney.png";
import Teacher from "../../assets/images/teacher.webp";
import styles from "./style.module.css";
// import SendMessage from "../../components/sendMessage";
import PlayButton from "../../assets/images/play button.png";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import CenterLoading from "../../components/loader/CenterLoader";
import Chat from "../../components/chat/chat";
import { fetchCoursesDataOnSearch } from "../../services/course";
import ModalComponent from "../../components/modal";

import { toast } from "react-toastify";
import {
  addDocToFirestore,
  clearLocalStorage,
  filterProfilePicture,
} from "../../helper";

import { useLocation, useNavigate } from "react-router-dom";
import {
  DEMO_TYPE,
  OFFER_TYPE_MESSAGES,
  SEARCH_URL,
  TEACHER_ROLE,
  filters,
  offerStatuses,
} from "../../constants";
import { baseUrl } from "../../services/api";
import Layout from "../../layout/Layout";
import Pagination from "../../components/pagination/Pagination";
import CreateOfferCard from "../../components/createOfferCard/CreateOfferCard";
import { fetchAllCities } from "../../services/cities";
import { fetchCityArea } from "../../services/areas";
import { fetchCourseLevels } from "../../services/course-levels";
import { fetchQualificationLevels } from "../../services/qualification";
import { fetchEducationBoards } from "../../services/board";
import TeacherDetailPopup from "./../../components/teacher-detail-popup/index";
import { getTeacherReviews } from "../../services/teacher";
import { Rate } from "antd";

let offset = 10;
const INITIAL_OFFER_DATA = {
  offerType: DEMO_TYPE,
};
const VerticalFilterComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  // Get the values of the query parameters
  const query = queryParams.get("query") || "";
  const gender = queryParams.get("gender") || "";
  const mode = queryParams.get("modeOfTeaching") || "";
  const city = queryParams.get("cityId") || "";
  const dispatch = useDispatch();

  const videoRef = useRef(null);
  const [subjectSearch, setSubjectSearch] = useState(query || "");
  const [selectedGender, setSelectedGender] = useState(gender || "");
  const [modeOfTeaching, setModeOfTeaching] = useState(mode || "");
  const [selectedCity, setSelectedCity] = useState(city || "");
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedCourseLevel, setSelectedCourseLevel] = useState("");
  const [qualificationLevel, setQualificationLevel] = useState("");
  const [selectedTeachingBoard, setSelectedTeachingBoard] = useState("");
  const [teacherDetail, setTeacherDetail] = useState(false);

  const [offerDetail, setOfferDetail] = useState({
    ...INITIAL_OFFER_DATA,
  });
  const [selectedItem, setSelectedItem] = useState({
    itemDetail: "",
    open: false,
  });
  const [openScheduleDemoModal, setOpenScheduleDemoModal] = useState({
    itemDetail: "",
    open: false,
  });
  const [selectedCheckboxFilters, setSelectedCheckboxFilters] = useState([]);
  const [openMessageModal, setOpenMessageModal] = useState({
    itemDetail: "",
    open: false,
  });

  const [loading, setLoading] = useState({
    courseSearchLoading: true,
    filterLoading: false,
    reviewsLoading: false,
  });

  const { courses, listLoading } = useSelector((state) => state.courses);
  const loggedInUser = useSelector((state) => state.auth.user);

  const [multiFilter, setMultiFilter] = useState([...filters]);
  const containerStyle = {
    backgroundImage: `url(${StudentsJourney})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "200px",
    backgroundRepeat: "no-repeat",
    width: "100%",
  };

  const [teachersData, setTeachersData] = useState([]);

  const [currentPage, onPageChange] = useState(1);
  const [sortBy, setSortBy] = useState("");
  console.log("sortBy", sortBy);
  const [reviewModal, setReviewModal] = useState(false);
  const [reviews, setReviews] = useState();

  const [recordsPerPage] = useState(6);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const totalPages = Math.ceil(teachersData?.length / recordsPerPage);
  useEffect(() => {
    if (!courses) {
      // dispatch(fetchCourses());
    }
  }, [dispatch, courses]);

  useEffect(() => {
    searchCourseData(subjectSearch, offset);

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchFilters();

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (city) {
      getCityAreas(city);
    }

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city]);

  const getCityAreas = async (cityId) => {
    try {
      const { status, data } = await fetchCityArea(cityId);
      if (status === 200) {
        if (data?.data?.length) {
          let filter = { filterHeader: "Area", filterOptions: data?.data };
          addMoreFilters(filter);
        }
      }
    } catch (error) {}
  };

  const onSelectFilter = async (
    e,
    headerIndex,
    headerOptionIndex,
    filterHeader,
    filterOption
  ) => {
    try {
      resetCurrentPage();

      let { value, checked } = e.target;
      let prev = [...selectedCheckboxFilters];
      if (checked) {
        prev.push(Number(value));
      } else {
        let filter = prev.filter((item) => item !== Number(value));
        prev = filter;
      }
      let prevFilters = [...multiFilter];
      for (
        let index = 0;
        index < prevFilters[headerIndex].filterOptions?.length;
        index++
      ) {
        const element = prevFilters[headerIndex].filterOptions?.[index];
        element.checked = false;
      }
      prevFilters[headerIndex].filterOptions[headerOptionIndex].checked =
        checked;
      setMultiFilter(prevFilters);
      setSelectedCheckboxFilters(prev);

      handleLoading("courseSearchLoading", true);

      let gender;
      let city;
      let teachingMode;
      let area;
      let level;
      let qualification;
      let teachingBoard;
      if (filterHeader === "Gender") {
        gender = filterOption;
        setSelectedGender(filterOption);
      } else {
        gender = selectedGender;
      }
      if (filterHeader === "Course Level") {
        level = value;
        setSelectedCourseLevel(value);
      } else {
        level = selectedCourseLevel;
      }
      if (filterHeader === "Education Board") {
        teachingBoard = value;
        setSelectedTeachingBoard(value);
      } else {
        teachingBoard = selectedTeachingBoard;
      }
      if (filterHeader === "Qualification Level") {
        qualification = value;
        setQualificationLevel(value);
      } else {
        qualification = qualificationLevel;
      }
      if (filterHeader === "City") {
        removeFilters("Area");

        await getCityAreas(value);
        city = value;
        setSelectedCity(value);
      } else {
        city = selectedCity;
      }
      if (filterHeader === "Area") {
        area = value;
        setSelectedArea(value);
      } else {
        area = selectedArea;
      }

      if (filterHeader === "Teaching Mode") {
        teachingMode = filterOption;
        setModeOfTeaching(filterOption);
      } else {
        teachingMode = modeOfTeaching;
      }

      upateURL(
        subjectSearch,
        gender,
        teachingMode,
        city,
        area,
        level,
        qualification,
        teachingBoard,
        sortBy
      );

      const { status, data } = await fetchCoursesDataOnSearch(
        subjectSearch,
        gender,
        teachingMode,
        city,
        area,
        level,
        qualification,
        teachingBoard,
        sortBy
      );
      if (status === 200) {
        // setSubjectSearch("");

        setTeachersData(data?.data);
      } else if (status === 401) {
        toast.error(data?.message);
        clearLocalStorage();
      } else {
        toast.error(data?.message);
      }
      handleLoading("courseSearchLoading", false);
    } catch (error) {
      handleLoading("courseSearchLoading", false);
    }
  };

  const handleLoading = (name, status) => {
    setLoading((pre) => ({
      ...pre,
      [name]: status,
    }));
  };

  const addMoreFilters = (filter) => {
    if (filter) {
      let duplicate = multiFilter?.find(
        (item) => item?.filterHeader === filter?.filterHeader
      );
      if (!duplicate) {
        setMultiFilter((prev) => [...prev, filter]);
      }
    }
  };

  const removeFilters = (filterHeader) => {
    if (filterHeader) {
      let prevFilters = multiFilter?.filter(
        (item) => item?.filterHeader !== filterHeader
      );
      setMultiFilter(prevFilters);
    }
  };

  const fetchFilters = async () => {
    try {
      await getAllCities();
      await getCourseLevels();
      await getQualificationLevles();
      await getTeachingBoards();
    } catch (error) {}
  };

  const getAllCities = async () => {
    try {
      const { status, data } = await fetchAllCities();
      if (status === 200) {
        if (data?.data?.length) {
          let filter = { filterHeader: "City", filterOptions: data?.data };

          addMoreFilters(filter);
          return data?.data;
        }
      }
    } catch (error) {}
  };

  const getTeachingBoards = async () => {
    try {
      const { status, data } = await fetchEducationBoards();
      if (status === 200) {
        if (data?.data?.length) {
          let filter = {
            filterHeader: "Education Board",
            filterOptions: data?.data,
          };

          addMoreFilters(filter);
          return data?.data;
        }
      }
    } catch (error) {}
  };
  const getQualificationLevles = async () => {
    try {
      const { status, data } = await fetchQualificationLevels();
      if (status === 200) {
        if (data?.data?.length) {
          let filter = {
            filterHeader: "Qualification Level",
            filterOptions: data?.data,
          };

          addMoreFilters(filter);
          return data?.data;
        }
      }
    } catch (error) {}
  };

  const getCourseLevels = async () => {
    try {
      const { status, data } = await fetchCourseLevels();
      if (status === 200) {
        if (data?.data?.length) {
          let filter = {
            filterHeader: "Course Level",
            filterOptions: data?.data,
          };
          addMoreFilters(filter);
        }
        return data?.data;
      }
    } catch (error) {}
  };

  const upateURL = (
    subjectSearch,
    selectedGender,
    modeOfTeaching,
    selectedCity,
    area,
    level,
    qualificationLevel,
    teachingBoard
  ) => {
    return navigate(
      `${SEARCH_URL}?query=${subjectSearch}&gender=${selectedGender}&modeOfTeaching=${modeOfTeaching}&cityId=${selectedCity}&areaId=${area}&course-level=${level}&qualification-level=${qualificationLevel}&education-board=${teachingBoard}&sortBy=${sortBy}`
    );
  };

  const resetCurrentPage = () => {
    onPageChange(1);
  };
  const searchCourseData = async (subject, offsetPassed) => {
    try {
      resetCurrentPage();
      // if (subject === "") return;

      // if(offsetPassed === 0) offset = 0;
      handleLoading("courseSearchLoading", true);
      // navigate(`${SEARCH_URL}?query=${subjectSearch}`);
      upateURL(
        subjectSearch,
        selectedGender,
        modeOfTeaching,
        selectedCity,
        selectedArea,
        selectedCourseLevel,
        qualificationLevel,
        selectedTeachingBoard,
        sortBy
      );

      //
      // const { status, data: res } = await fetchCoursesDataOnSearch(subject);

      const { status, data: res } = await fetchCoursesDataOnSearch(
        subject,
        selectedGender,
        modeOfTeaching,
        selectedCity,
        selectedArea,
        selectedCourseLevel,
        qualificationLevel,
        selectedTeachingBoard,
        sortBy
      );
      if (status === 200) {
        if (res?.data?.length) {
          console.log("res?.data  without filter", res?.data);
          setTeachersData(res?.data);
        }
      }

      handleLoading("courseSearchLoading", false);
    } catch (error) {
      handleLoading("courseSearchLoading", false);
    }
  };

  //  const handleSortBy = (value) => {
  //     setSortBy(value)
  //     searchCourseData()
  //   }

  useEffect(() => {
    searchCourseData();
  }, [sortBy]);

  const handleShowMore = () => {
    offset = offset + 6;
    searchCourseData(subjectSearch, offset);
  };

  const handleScheduleDemoModal = (status, item) => {
    setOpenScheduleDemoModal({
      open: status,
      itemDetail: item,
    });
  };

  const handleMessageModal = (status, item) => {
    setOpenMessageModal({
      open: status,
      itemDetail: item,
    });
  };

  const handleCollapseFilter = (index, status) => {
    let temp = [...multiFilter];

    temp[index].isOpen = status;
    setMultiFilter(temp);
  };

  const handleVideoModal = (status, item) => {
    setSelectedItem({
      open: status,
      itemDetail: item,
    });
  };

  const handleCloseVideoModal = () => {
    // Pause the video when the modal is closed
    if (videoRef.current) {
      videoRef.current.pause();
    }

    // Close the modal
    handleVideoModal(false, "");
  };

  const filterCourses = (courses, currentUser) => {
    // let filterCourse = courses?.filter(
    //   (item) => item?.uuid !== currentUser?.uuid
    // );
    return courses;
  };

  const clearFilter = async (filterHeader) => {
    try {
      resetCurrentPage();

      handleLoading("courseSearchLoading", true);
      let resetFilter = [...multiFilter];
      for (let index = 0; index < resetFilter?.length; index++) {
        const element = resetFilter?.[index];
        if (element?.filterHeader === filterHeader) {
          let filterOptions = element?.filterOptions.map((item) => {
            return {
              ...item,
              checked: false,
            };
          });
          element.filterOptions = filterOptions;
        }
      }
      setMultiFilter(resetFilter);
      let gender;
      let city;
      let mode;
      let area;
      let level;
      let qualification;
      let teachingBoard;
      if (filterHeader === "Gender") {
        gender = "";
        setSelectedGender("");
      } else {
        gender = selectedGender;
      }
      if (filterHeader === "Education Board") {
        teachingBoard = "";
        setSelectedTeachingBoard("");
      } else {
        teachingBoard = selectedTeachingBoard;
      }
      if (filterHeader === "Qualification Level") {
        qualification = "";
        setSelectedGender("");
      } else {
        qualification = qualificationLevel;
      }
      if (filterHeader === "Course Level") {
        level = "";
        setSelectedCourseLevel("");
      } else {
        level = selectedCourseLevel;
      }
      if (filterHeader === "City") {
        city = "";
        area = "";
        setSelectedCity("");
        setSelectedArea("");
      } else {
        city = selectedCity;
      }
      if (filterHeader === "Area") {
        area = "";
        setSelectedArea("");
      } else {
        area = selectedArea;
      }

      if (filterHeader === "Teaching Mode") {
        mode = "";
        setModeOfTeaching("");
      } else {
        mode = modeOfTeaching;
      }

      const { status, data } = await fetchCoursesDataOnSearch(
        subjectSearch,
        gender,
        mode,
        city,
        area,
        level,
        qualification,
        teachingBoard
      );
      upateURL(
        subjectSearch,
        gender,
        mode,
        city,
        area,
        level,
        qualification,
        teachingBoard
      );
      if (status === 200) {
        setTeachersData(data?.data);
      } else if (status === 401) {
        toast.error(data?.message);
        clearLocalStorage();
      } else {
        toast.error(data?.message);
      }
      handleLoading("courseSearchLoading", false);
    } catch (error) {
      handleLoading("courseSearchLoading", false);
    }
  };

  const filterIntroVideo = (list) => {
    if (list?.length) {
      let introVideo = list?.find((item) => item?.type === "introVideos");
      if (introVideo) {
        return `${baseUrl}${introVideo?.url}`;
      }
    }
  };

  const sendOffer = async (offerData) => {
    try {
      let messageBody = {
        text: OFFER_TYPE_MESSAGES.DEMO,
        sender_uuid: loggedInUser?.uuid,
        senderName: loggedInUser?.fullName,
        receiver_uuid: openScheduleDemoModal?.itemDetail?.uuid,
        receiverId: openScheduleDemoModal?.itemDetail?.id,
        receiverName: openScheduleDemoModal?.itemDetail?.fullName,
        timestamp: new Date(),
        seen: false,
        offerDetail: { ...offerData, offerStatus: offerStatuses.PENDING },
      };
      await addDocToFirestore(
        loggedInUser?.uuid,
        openScheduleDemoModal?.itemDetail?.uuid,
        messageBody
      );
      handleScheduleDemoModal(false, {});
    } catch (error) {}
  };

  const handleDetail = (detail) => {
    console.log("detail", detail);
    setTeacherDetail(detail);
  };

  const handleShowReviews = async (teacherId) => {
    debugger;
    try {
      setReviewModal(true);
      handleLoading("reviewsLoading", true);
      const { status, data } = await getTeacherReviews(teacherId);
      if (status === 200) {
        if (data?.data?.length) {
          setReviews(data?.data);
        }
      }
      handleLoading("reviewsLoading", false);
    } catch (error) {
      handleLoading("reviewsLoading", false);
    }
  };

  const LayoutRender = loggedInUser?.role ? StudentLayout : Layout;
  return (
    <LayoutRender>
      {/* <SignIn openLogIn={openLogin} handleLogInModal={handleLogin} /> */}
      <CreateOfferCard
        setOfferDetail={setOfferDetail}
        offerDetail={offerDetail}
        teacherId={openScheduleDemoModal?.itemDetail.id}
        studentId={loggedInUser?.id}
        onSendOffer={sendOffer}
        handleOk={() => handleScheduleDemoModal(false, {})}
        handleCancel={() => handleScheduleDemoModal(false, {})}
        open={openScheduleDemoModal?.open}
      />
      {reviewModal ? (
        <ModalComponent
          zIndex={10000}
          title={"Teacher Review"}
          show={reviewModal}
          onCancel={() => {
            setReviewModal(false);
            setReviews([]);
          }}
        >
          <h6>Reviews</h6>
          {loading?.reviewsLoading ? (
            "Loading..."
          ) : (
            <div
              className={`row pb-3 overflow-y-scroll ${styles.reviews} ${styles.scrollbar_custom}`}
            >
              {reviews?.length > 0 ? (
                reviews
                  ?.filter((review) => review?.review)
                  .map((review, index) => (
                    <div className="" key={index}>
                      <div
                        className={`my-1 bg-light pt-1 pl-2 ${styles.border_color}`}
                      >
                        {/* <div className=""> */}
                        <div className="fs_12 mb-1 px-2">
                          {review?.review || "No reviews"}
                        </div>
                        {/* </div> */}
                      </div>
                    </div>
                  ))
              ) : (
                <div className="col-12 my-3">
                  <p className="fs_12">No reviews available.</p>
                </div>
              )}
            </div>
          )}

          <div className="d-flex justify-content-end">
            {/* <button
              onClick={handleCanclereviewModal}
              disabled={loading}
              className="btn btn_outlined me-2"
            >
              Cancel
            </button> */}

            <button
              onClick={() => {
                setReviewModal(false);
                setReviews([]);
              }}
              // disabled={loading}
              className="btn btn-primary btn_contained"
            >
              {/* {loading ? <Loader /> : "Proceed"} */}
              Ok
            </button>
          </div>
        </ModalComponent>
      ) : (
        ""
      )}

      {/* video modal */}
      {
        <Modal
          maskClosable={false}
          width={700}
          footer={null}
          title=""
          open={selectedItem?.open}
          onOk={() => handleCloseVideoModal()}
          onCancel={() => handleCloseVideoModal()}
        >
          <div className="m-4">
            <video
              key={selectedItem?.itemDetail}
              ref={videoRef}
              autoPlay
              controls
              controlsList="nodownload"
              width={600}
              height={400}
            >
              <source src={selectedItem?.itemDetail} type="video/mp4" />
            </video>
          </div>
        </Modal>
      }

      <Modal
        maskClosable={false}
        width={700}
        footer={null}
        closable
        title=""
        open={openMessageModal?.open}
        onOk={() => handleMessageModal(false, "")}
        onCancel={() => handleMessageModal(false, "")}
      >
        <Chat receiver={openMessageModal?.itemDetail} />
      </Modal>
      {listLoading ? (
        <CenterLoading />
      ) : (
        <div className="container-fluid ">
          <div className="row">
            <div
              className="col-md-12 padd_left_right_70"
              style={containerStyle}
            >
              {/* Content within the full-width background */}
              <h2
                style={{ paddingTop: "73px" }}
                className="text-white text-uppercase"
              >
                student journey
              </h2>
              {/* <div
                className="text-center text-white "
                style={{ paddingTop: "25px" }}
              >
                <span className="me-3">Matric</span>
                <span className="me-3">Math</span>
              </div> */}
            </div>
          </div>
          <div
            className={`row ${loggedInUser?.role ? "" : "padd_left_right_70"}`}
          >
            {/* Filter Sidebar (col-md-4) */}
            <div className={`col-md-3 ${styles["filter-container"]}`}>
              <div className="d-flex bg-white rounded-5 py-1 px-2 mb-4">
                <input
                  type="search"
                  className="form-control fs_12 border-0 form_control_focus_box_shadow_none"
                  placeholder="Search Subject"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  value={subjectSearch}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      searchCourseData(e.target.value, offset);
                    }
                  }}
                  onChange={(e) => setSubjectSearch(e.target.value, 6)}
                />
                <AiOutlineSearch
                  className={`${styles.searhIcon}`}
                  onClick={() => searchCourseData(subjectSearch, 0)}
                />
              </div>

              {/* City Checkbox Options */}
              {loading?.filterLoading ? (
                [1, 2, 3]?.map((item, index) => {
                  return (
                    <p key={index} className="card-text placeholder-glow mb-5 ">
                      <span className="placeholder col-10 d-block mb-3"></span>
                      <span className="d-block mb-2">
                        <span className="placeholder col-1  me-2"></span>
                        <span className="placeholder col-4  "></span>
                      </span>
                      <span className="d-block mb-2">
                        <span className="placeholder col-1  me-2"></span>
                        <span className="placeholder col-4  "></span>
                      </span>
                      <span className="d-block mb-2">
                        <span className="placeholder col-1  me-2"></span>
                        <span className="placeholder col-4  "></span>
                      </span>
                    </p>
                  );
                })
              ) : multiFilter?.length ? (
                multiFilter?.map((item, index) => {
                  return (
                    <div className="mb-3" key={index}>
                      <div className="d-flex justify-content-between">
                        <label className="form-label primary_text_color fw-bold">
                          {item?.filterHeader}
                        </label>

                        {item?.isOpen ? (
                          <RiArrowDropUpLine
                            style={{ cursor: "pointer" }}
                            className="primary_text_color"
                            onClick={() => handleCollapseFilter(index, false)}
                            size={30}
                          />
                        ) : (
                          <RiArrowDropDownLine
                            style={{ cursor: "pointer" }}
                            className="primary_text_color"
                            onClick={() => handleCollapseFilter(index, true)}
                            size={30}
                          />
                        )}
                      </div>
                      <hr />

                      {!item?.isOpen &&
                        item?.filterOptions?.map((innerItem, innerIndex) => {
                          return (
                            <div className="form-check" key={innerItem?.id}>
                              <input
                                checked={innerItem?.checked}
                                name={item?.filterHeader}
                                value={innerItem?.id}
                                onChange={(e) =>
                                  onSelectFilter(
                                    e,
                                    index,
                                    innerIndex,
                                    item?.filterHeader,
                                    innerItem?.name
                                  )
                                }
                                className="form-check-input"
                                type="radio"
                                id={innerItem?.id}
                              />
                              <label
                                className="form-check-label fs_12"
                                htmlFor="cityCheckbox1"
                              >
                                {innerItem?.name}
                              </label>
                            </div>
                          );
                        })}
                      {item?.filterOptions?.some((item) => item?.checked) ? (
                        <u>
                          <p
                            style={{ color: "#0000ff96" }}
                            className="pt-2 fs_12 cursor_pointer"
                            onClick={() => {
                              clearFilter(item?.filterHeader);
                            }}
                          >
                            clear filter
                          </p>
                        </u>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })
              ) : (
                <p className="d-flex justify-content-center align-items-center fs_12 vh-100">
                  No record found.
                </p>
              )}
            </div>

            {/* Main Content (col-md-8) */}
            <div className={`col-md-9`}>
              <div
                className="mt-2 mb-4 p-2"
                style={{ backgroundColor: "#87ceeb26" }}
              >
                <div className=" d-flex">
                  <span style={{ width: "77px" }} className="mt-2 me-3 fs_12">
                    Sort by:
                  </span>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    <option value="">None</option>
                    <option value="ratings">Ratings</option>
                    {/* <option value="3">Experiance</option> */}
                  </select>
                </div>
              </div>
              {!loggedInUser?.role ? (
                <div className="sky-bg-color p-2 mb-4">
                  <span className="fs_14">
                    You need to <b>Login</b> first to Send message or Schedule a
                    demo.
                  </span>
                </div>
              ) : (
                ""
              )}

              {/* Your main content goes here */}
              {/* Add your car listings or other content here */}
              <div className="row px-lg-5">
                {loading?.courseSearchLoading ? (
                  [1, 2, 3, 4]?.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={`mb-5 col-md-6`}
                        aria-hidden="true"
                      >
                        <div className="placeholder-glow mb-2">
                          <span
                            style={{ height: "150px" }}
                            className="placeholder  col-7"
                          ></span>
                        </div>
                        <div className="card-body">
                          <h5 className="card-title mb-2 placeholder-glow">
                            <span className="placeholder  col-6"></span>
                          </h5>
                          <p className="card-text placeholder-glow">
                            <span className="d-block mb-2">
                              <span className="placeholder col-2  me-2"></span>
                              <span className="placeholder col-2  "></span>
                            </span>
                            <span className="d-block mb-2">
                              <span className="placeholder col-3  me-2"></span>
                              <span className="placeholder col-1  "></span>
                            </span>
                            <span className="placeholder mb-2 d-block col-6"></span>
                          </p>
                          <button
                            type="button"
                            className="col-4 disabled placeholder btn btn-primary text-uppercase btn-sm me-2 mb-3 btn_contained"
                          ></button>
                          <button
                            type="button"
                            className="col-4 disabled placeholder btn btn-primary text-uppercase btn-sm me-2 mb-3 btn_contained"
                          ></button>
                        </div>
                      </div>
                    );
                  })
                ) : teachersData?.length ? (
                  <>
                    {filterCourses(teachersData, loggedInUser)
                      ?.slice(indexOfFirstRecord, indexOfLastRecord)
                      ?.map((item) => {
                        console.log("item", item);
                        return (
                          <div key={item?.id} className={`mb-5 col-md-6`}>
                            <div
                              className="d-lg-flex"
                              style={{ height: "180px" }}
                            >
                              {filterIntroVideo(item?.teacherMedia) ? (
                                <div style={{ position: "relative" }}>
                                  <video
                                    // width="150"
                                    // height={180}
                                    className={`${styles["media"]} primary_dark_bg_color`}
                                  >
                                    <source
                                      src={filterIntroVideo(item?.teacherMedia)}
                                    />
                                  </video>
                                  <img
                                    onClick={() =>
                                      handleVideoModal(
                                        true,
                                        filterIntroVideo(item?.teacherMedia)
                                      )
                                    }
                                    className="cursor_pointer"
                                    width={35}
                                    style={{
                                      position: "absolute",
                                      top: "60px",
                                      left: "60px",
                                    }}
                                    src={PlayButton}
                                    alt="play button"
                                  />
                                </div>
                              ) : filterProfilePicture(item?.teacherMedia) ? (
                                <img
                                  // src={item?.image}
                                  src={filterProfilePicture(item?.teacherMedia)}
                                  className={`${styles["teacher-profile"]} img-fluid`}
                                  alt="Teacher"
                                />
                              ) : (
                                <img
                                  className={`${styles["teacher-profile"]} img-fluid`}
                                  src={Teacher}
                                  alt="Teacher"
                                />
                              )}

                              <div className="ms-lg-3 fs_12">
                                <div className="pb-2">
                                  <span className="text-secondary">Name</span>
                                  <br />
                                  <span className="fw-bold">
                                    {item?.fullName}
                                  </span>
                                </div>
                                <div className="pb-2">
                                  <span className="text-secondary">
                                    {" "}
                                    Highest Qualification
                                  </span>
                                  <br />
                                  <span className="fw-bold">
                                    <div className="d-flex flex-wrap">
                                      {item?.teacherEducations?.length
                                        ? item?.teacherEducations?.map(
                                            (cur, i) =>
                                              i ===
                                              item?.teacherEducations?.length -
                                                1 ? (
                                                <span key={i}>
                                                  {`${
                                                    cur?.qualification || "N/A"
                                                  }`}
                                                </span>
                                              ) : (
                                                <span key={i}>
                                                  {` ${
                                                    cur?.qualification || "N/A"
                                                  }`}
                                                  ,
                                                </span>
                                              )
                                          )
                                        : "N/A"}
                                    </div>
                                    {/* {item?.qualification} */}
                                  </span>
                                </div>
                                <div className="pb-2">
                                  <span className="text-secondary">
                                    {" "}
                                    Subject Expertise
                                  </span>
                                  <br />
                                  <span className="fw-bold">
                                    {/* <div className="d-flex flex-wrap"> */}
                                    <div className={styles.courseEllipsis}>
                                      {item?.courses?.length
                                        ? item?.courses?.map((cur, i) =>
                                            i === item?.courses?.length - 1 ? (
                                              <span key={i}>
                                                {cur?.courseSubjectName}
                                              </span>
                                            ) : (
                                              <span key={i}>
                                                {cur?.courseSubjectName},
                                              </span>
                                            )
                                          )
                                        : "N/A"}
                                    </div>
                                  </span>
                                </div>
                                <div className="pb-2">
                                  <span className="text-secondary">
                                    Ratings
                                  </span>
                                  <br />
                                  <span className="fw-bold">
                                    <Rate
                                      onClick={() =>
                                        handleShowReviews(item?.id)
                                      }
                                      disabled
                                      value={Math.round(parseInt(item?.rating))}
                                      style={{
                                        fontSize: "14px",
                                        marginRight: "5px",
                                      }}
                                    />
                                    ({item?.ratingCount})
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* <PopOverMenu
                              placement="bottom"
                              content={
                                <div
                                  style={{
                                    minHeight: "100px",
                                    maxHeight: "300px",
                                    overflowY: "scroll",
                                    padding: "0px 10px",
                                  }}
                                >
                                  <TeacherDetailPopup teacherDetail={item} />
                                </div>
                              }
                              button={
                                <u>
                                  <span
                                    onClick={() => handleDetail(item)}
                                    className="fs_12"
                                  >
                                    View Detail
                                  </span>
                                </u>
                              }
                            /> */}
                            <u>
                              <span
                                onClick={() => handleDetail(item)}
                                className="fs_12 cursor_pointer"
                              >
                                View Detail
                              </span>
                            </u>
                            <div className="card-body mt-3">
                              <button
                                disabled={
                                  !loggedInUser?.id ||
                                  loggedInUser?.role === TEACHER_ROLE
                                }
                                onClick={() => handleMessageModal(true, item)}
                                type="button"
                                className="btn btn-primary  btn-sm me-2 mb-3 btn_contained"
                              >
                                Send a Message
                              </button>
                              <button
                                disabled={
                                  !loggedInUser?.id ||
                                  loggedInUser?.role === TEACHER_ROLE
                                }
                                onClick={() =>
                                  handleScheduleDemoModal(true, item)
                                }
                                type="button"
                                className="btn btn-outline-primary   btn-sm mb-3 btn_outlined"
                              >
                                schedule a demo
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    <div className=" d-flex justify-content-center mb-4">
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}
                      />
                    </div>
                    {/* <div className="text-center mb-3">
                      <ButtonComponents
                        onClick={() => handleShowMore()}
                        type="primary"
                      >
                        Show More
                      </ButtonComponents>
                    </div> */}
                  </>
                ) : (
                  <p className="d-flex justify-content-center align-items-center fs_12 vh-100">
                    No record found.
                  </p>
                )}
              </div>
            </div>
            {teacherDetail ? (
              <div
                className={`rounded-4 col-md-4 ${styles["teacher-detail"]} primary_bg_color text-white p-3 hide-scroll`}
                style={{
                  maxHeight: "500px",
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none"
                }}
              >
                <TeacherDetailPopup
                  onClose={() => handleDetail("")}
                  teacherDetail={teacherDetail}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
    </LayoutRender>
  );
};

export default VerticalFilterComponent;
